import { render, staticRenderFns } from "./BlocoVejaMaisAnimado.vue?vue&type=template&id=14ca2718&scoped=true"
import script from "./BlocoVejaMaisAnimado.vue?vue&type=script&lang=js"
export * from "./BlocoVejaMaisAnimado.vue?vue&type=script&lang=js"
import style0 from "./BlocoVejaMaisAnimado.vue?vue&type=style&index=0&id=14ca2718&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ca2718",
  null
  
)

export default component.exports